import * as requests from '../api-request'

export const save = async (data) => {
  return requests.toJSON('POST', 'video/save', data)
}

export const generateFrames = async (data) => {
  return requests.toJSON('POST', 'video/generate_frames', data)
}

export const drawImage = async (data) => {
  return requests.toJSON('POST', 'video/draw_image', data)
}

export const generateVideo = async (data) => {
  return requests.toJSON('POST', 'video/generate_video', data)
}

export const uploadFile = async (data) => {
  return requests.toJSON('POST', 'video/upload', data)
}

export const getAssets = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `video/assets?${queryString}`, data)
}

export const deleteAsset = async (id) => {
  return requests.toJSON('DELETE', `video/assets/${id}`)
}

export const publishAsset = async (data) => {
  return requests.toJSON('POST', 'video/assets/add_to_library', data)
}

export const getVoices = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `video/audio/voices?${queryString}`, data)
}

export const generateVoice = async (data) => {
  const response = await requests.toJSON('POST', 'video/audio/voice', data)
  return response.audio
}

export const generateSound = async (data) => {
  const response = await requests.toJSON('POST', 'video/audio/sound', data)
  return response.audio
}

export const generateMusic = async (data) => {
  const response = await requests.toJSON('POST', 'video/audio/music', data)
  return response.audio
}

export const getLatest = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `video/latest?${queryString}`, data)
}

export const calculateAudioCredit = async (data) => {
  return requests.toJSON('POST', 'video/audio/calculate_credits', data)
}

export const calculateSoundCredit = async (data) => {
  return requests.toJSON('POST', 'video/audio/sound/calculate_credits', data)
}

export const calculateVideoCredit = async (data) => {
  return requests.toJSON('POST', 'video/calculate_credits', data)
}

export const calculateImageCredit = async (data) => {
  return requests.toJSON('POST', 'video/calculate_image_credits', data)
}

export const render = async (data) => {
  return requests.toJSON('POST', 'video/render', data)
}

export const renderProgress = async (data) => {
  return requests.toJSON('POST', 'video/render/progress', data)
}

export const renderHistory = async (data) => {
  return requests.toJSON('POST', 'video/render/history', data)
}

export const getVideoSettings = async (data) => {
  return requests.toJSON('POST', 'video/settings/get', data)
}

export const saveVideoSettings = async (data) => {
  return requests.toJSON('POST', 'video/settings/save', data)
}

export const describeLocation = async (data) => {
  return requests.toJSON('POST', 'video/describe_location', data)
}

export const removeBackground = async (data) => {
  return requests.toJSON('POST', 'video/effects/remove_background', data)
}

export const changeBackground = async (data) => {
  return requests.toJSON('POST', 'video/effects/change_background', data)
}

export const createSurpriseVideo = async (data) => {
  return requests.toJSON('POST', 'video/create_video_for_user', data)
}

export const checkTask = async (assetId) => {
  return requests.toJSON('GET', `video/assets/task/${assetId}`)
}

export const getAvailableVideoModels = async () => {
  return requests.toJSON('GET', 'video/available_video_models')
}

export const getAvailableImageModels = async () => {
  return requests.toJSON('GET', 'video/available_image_models')
}

export const getVoicePreview = async (voiceId) => {
  return requests.toJSON('GET', `video/audio/voices/${voiceId}`)
}

export const addAudioOnVideo = async (data) => {
  return requests.toJSON('POST', 'video/audio/add_on_video', data)
}

export const remixVideo = async (data) => {
  return requests.toJSON('POST', 'video/remix', data)
}

export const upscale = async (data) => {
  return requests.toJSON('POST', 'video/upscale', data)
}

export const getProductionPipelines = async () => {
  return requests.toJSON('GET', 'video/productions/pipelines')
}

export const estimateProduction = async (data) => {
  return requests.toJSON('POST', 'video/productions/estimate', data)
}

export const createProduction = async (data) => {
  return requests.toJSON('POST', 'video/productions', data)
}

export const listProductions = async (data = {}) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `video/productions?${queryString}`, data)
}

export const getProduction = async (productionUuid) => {
  return requests.toJSON('GET', `video/productions/${productionUuid}`)
}

export const startProduction = async (productionUuid, data = {}) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/start`, data)
}

export const sendProductionMessage = async (productionUuid, data) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/messages`, data)
}

export const approveProduction = async (productionUuid, data = {}) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/approve`, data)
}

export const insertProductionEditor = async (productionUuid, data = {}) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/insert-editor`, data)
}

export const retryProduction = async (productionUuid) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/retry`)
}

export const renderProduction = async (productionUuid) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/render`)
}

export const updateProductionRenderResult = async (productionUuid, data) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/render-result`, data)
}

export const cancelProduction = async (productionUuid) => {
  return requests.toJSON('POST', `video/productions/${productionUuid}/cancel`)
}

export const deleteProduction = async (productionUuid) => {
  return requests.toJSON('DELETE', `video/productions/${productionUuid}`)
}
